import React, { Component } from 'react';

import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

class Benefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeBox: { ...this.props.mainContent }
    };
  }

  componentDidMount = () => {
    window.addEventListener('reload', this.reload);
  };

  componentWillUnmount = () => {
    window.removeEventListener('reload', this.reload);
  };

  reload = () => {
    this.setState({
      activeBox: { ...this.props.mainContent }
    });
  };

  changeActiveContentHandler = box => {
    /*this.setState({
      activeBox: {
        header: box.header,
        content: box.content,
        id: box.id
      }
    });*/
  };

  render() {
    let styles = {};
    if (window.innerWidth < 992) {
      styles.minHeight = this.props.screenHeight + 'px';
    } else {
      styles.height = this.props.screenHeight + 'px';
    }

    return (
      <div
        id={this.props.id}
        className={
          window.innerWidth < 992
            ? this.props.className + ' flex-column'
            : this.props.className
        }
        style={styles}
      >
        {window.innerWidth < 992 ? (
          <Mobile
            {...this.state}
            {...this.props}
            click={box => this.changeActiveContentHandler(box)}
          />
        ) : (
          <Desktop
            {...this.props}
            {...this.state}
            click={box => this.changeActiveContentHandler(box)}
          />
        )}
      </div>
    );
  }
}

export default Benefits;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/Benefits/Benefits.js